import { _fetch as fetchSecure } from '@hobs/utils/fetch';

import { UNITS, GET, UNITS_CURRENT } from '@hobs/constants/parties';

export function getPartyUnits() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('parties/current/units')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UNITS.REQUEST };
  }
  function success(response) {
    return { type: UNITS.SUCCESS, response };
  }
  function failure(error) {
    return { type: UNITS.FAILURE, error };
  }
}

export function getParty() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('parties/current')
      .then(response => {
        if (response.payload) {
          dispatch(success(response.payload));
          return { success: true };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }
  function success(response) {
    return { type: GET.SUCCESS, response };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function getAssignedPartyUnits() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('parties/current/units/current')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));
          return { success: true, ...response };
        }

        dispatch(failure(response.toString()));
        return { success: false, ...response };
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UNITS_CURRENT.REQUEST };
  }
  function success(response) {
    return { type: UNITS_CURRENT.SUCCESS, response };
  }
  function failure(error) {
    return { type: UNITS_CURRENT.FAILURE, error };
  }
}
